import view from './view.html';

/* @ngInject */
export default function ($compile) {
	return {
		template:                   view,
		replace:                    true,
		scope:                      {
			reportId:   '@',
			parameters: '=?',
		},
		controller: /* @ngInject */ ($scope) => {
			$scope.directiveName = `report${btoa($scope.reportId)
				.toLowerCase()}`;

			if (!$scope.parameters) {
				$scope.parameters = {};
			}
		},
		link:                       (scope, element, attrs) => {
			element.append($compile(`<${scope.directiveName}></${scope.directiveName}>`)(scope));
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/index.js